/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';
import type { RouteContext } from '@atlassian/react-resource-router';

type AllProps = RouteContext;

export const LegacyEditPermissionsPage = (props: AllProps): React.JSX.Element => (
	<>
		<LegacyPage {...props} />
	</>
);

export default LegacyEditPermissionsPage;
